const ERROR_LOG_KEY = 'site_errors';
const MAX_ERRORS = 50;

export interface ErrorEntry {
  message: string;
  source: string;
  time: string;
}

export const getErrors = (): ErrorEntry[] => {
  try {
    return JSON.parse(localStorage.getItem(ERROR_LOG_KEY) || '[]');
  } catch {
    return [];
  }
};

export const clearErrors = () => {
  localStorage.removeItem(ERROR_LOG_KEY);
};

const logError = (message: string, source: string) => {
  const errors = getErrors();
  errors.unshift({ message, source, time: new Date().toISOString() });
  localStorage.setItem(ERROR_LOG_KEY, JSON.stringify(errors.slice(0, MAX_ERRORS)));
};

export const initErrorLogger = () => {
  window.addEventListener('error', (e) => {
    logError(e.message, `${e.filename}:${e.lineno}`);
  });

  window.addEventListener('unhandledrejection', (e) => {
    logError(String(e.reason), 'unhandled promise rejection');
  });

  const originalError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    logError(args.map(String).join(' '), 'console.error');
    originalError(...args);
  };
};
